import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFastIntake = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "fastintake",
	"data-name": "fastintake",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M 17.187891,0.7268006 15.222572,6.863342 a 3.18437,4.3805143 49.548838 0 1 -3.112684,3.352551 v 0 a 3.18437,4.3805143 49.548838 0 1 -3.3525514,0 v 0 A 3.18437,4.3805143 49.548838 0 1 7.7136401,6.863342 L 9.6789588,0.7268006",
			id: "path268"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 13.433428,
			y1: .72680068,
			x2: 6.212604,
			y2: 23.273203,
			id: "line270"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 25.455085,7.3044674 a 3.201086,4.4035096 49.548838 1 1 -7.50893,0 c 0.665572,-2.0781898 3.48148,-5.6365996 5.559672,-5.6365996 2.078188,0 2.61483,3.5584098 1.949258,5.6365996 z",
			id: "path272"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 16.586395,
			y1: 23.273203,
			x2: 20.498198,
			y2: 11.058932,
			id: "line274"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: -1.8963791,
			y1: 15.232018,
			x2: 4.8219852,
			y2: 15.232018,
			id: "line854"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: -.54708385,
			y1: 12.239421,
			x2: 4.8219852,
			y2: 12.239421,
			id: "line856"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: .78815591,
			y1: 9.2594738,
			x2: 4.8219852,
			y2: 9.2594738,
			id: "line858"
		})
	]
});
const ForwardRef = forwardRef(SvgFastIntake);
export default ForwardRef;
